import {
  Badge,
  Switch,
  createStyles,
  rem,
  Modal,
  Text,
  Button,
  Flex,
  Menu,
} from "@mantine/core";
import { BsThreeDotsVertical } from "react-icons/bs";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { updateStaffStatusSkypoint } from "../../services/staff";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SkypointStaffModal from "../../containers/StaffModal/SkypointStaffModal";

const useStyles = createStyles((theme) => ({
  StaffSwitchCell: {
    paddingTop: rem(12),
    paddingBottom: rem(12),
    paddingLeft: 20,
    fontFamily: "Inter",
    height: "100%",
  },
  StaffSwitchBtn: {
    height: "32px",
    width: "61px",
  },
  border: {
    borderLeft: "1px solid #F2F2F2",
  },
  bg1: {
    "& td": {
      background: "#fff",
    },
    cursor: "pointer",
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
    cursor: "pointer",
  },
}));

const SkyPointStaffTableRow = ({ row, index, selectedTab }) => {
  const { classes } = useStyles();
  const [view, setView] = useState(false);
  const [active, setActive] = useState(row.active);
  const [opened, { open, close }] = useDisclosure(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const { profile } = useSelector((state) => state?.profile);
  const isAdmin = profile?.user?.id === row?.id;
  // The business owner/admin row, flagged by the API (StaffService.getOwnerRow).
  // It is listed so admins get a Staff Details view — and with it a Documents
  // section — but it is not a seat and must never be deactivated or removed.
  // `isAdmin` alone is not enough: it only matches when the owner is the one
  // looking, so a staff member viewing the list could still flip the switch.
  const isOwner = row?.isOwner === true;
  const isProtected = isOwner || isAdmin;
  const bg = index % 2 === 0;
  const navigate = useNavigate();

  useEffect(() => {
    setActive(row?.active);
  }, [row, active]);

  const handleEditClick = (e) => {
    navigate(`/home/staff-skypoint/${row?.id}/edit`);
  };

  const handleRowClick = () => {
    navigate(`/home/staff-skypoint/${row?.id}/view`);
  };

 

  const updateStatus = async (isChecked) => {
    try {
      setActive(isChecked);
      const rep = await updateStaffStatusSkypoint(
        { id: row?.id, active: isChecked },
        true,
        selectedTab
      );
      if (!rep?.success) {
        throw new Error("Failed to update staff status");
      }
    } catch (error) {
      setActive((prev) => !prev);
    }
  };

  // Function to handle the switch toggle
  const handleSwitchToggle = () => {
    if (!active) {
      if (row?.isEmailVerified) updateStatus(true);
      else setConfirmationOpen(true);
    } else {
      updateStatus(false);
    }
  };

  const handleConfirmationSubmit = (forceActivate) => {
    setConfirmationOpen(false);
    updateStatus(forceActivate);
  };

  let firstName = row?.firstName;
  let lastName = row?.lastName;

  if (!firstName && row?.name) {
    const [first, ...rest] = row?.name?.split(" ");
    firstName = first;
    lastName = rest?.length ? rest?.join(" ") : "-";
  }

  return (
    <tr
      style={{ cursor: "pointer" }}
      className={bg ? classes.bg2 : classes.bg1}
    >
      <td onClick={handleRowClick}>
        {firstName || "-"}
        {isOwner && (
          <Badge ml={8} size="sm" radius="sm" color="yellow" variant="light">
            Owner
          </Badge>
        )}
      </td>
      <td onClick={handleRowClick}>{lastName || "-"}</td>
      {/* <td onClick={handleRowClick}>{row?.firstName || row?.name || "-"}</td> */}
      {/* <td onClick={handleRowClick}>{row?.lastName || "-"}</td> */}
      <td onClick={handleRowClick}>
        {row?.providerId?.map((f) => f?.name)?.join(", ") || "-"}
      </td>
      <td onClick={handleRowClick}>{row?.position || "-"}</td>
      <td onClick={handleRowClick}>{row?.email || "-"}</td>
      <td>
        <Switch
          size="md"
          color="yellow"
          checked={active}
          onChange={handleSwitchToggle}
          className={classes.StaffSwitchBtn}
          disabled={isProtected}
        />
      </td>
      {/* <td onClick={handleRowClick} style={{ textTransform: "capitalize" }}>
        {"-"}
      </td> */}
      {/* <td>
        <ActionIcon
          variant="light"
          onClick={resetPassword}
          // disabled={isAdmin}
        >
          <IconKey />
        </ActionIcon>
      </td> */}
      <td>
        <Menu shadow="md" width={120} withinPortal>
          <Menu.Target>
            <Button variant="unstyled" p={0}>
              <BsThreeDotsVertical />
            </Button>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={handleRowClick}>View</Menu.Item>
            <Menu.Item onClick={handleEditClick} disabled={isProtected}>Edit</Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </td>
      <SkypointStaffModal
        opened={opened}
        onclose={close}
        title={"Edit Staff"}
        data={row}
        view={view}
        setView={setView}
        selectedTab={selectedTab}
      />
      <Modal
        size="sm"
        opened={confirmationOpen}
        title="Email not verified"
        overlayProps={{ blur: 3 }}
        zIndex={1000}
        onClose={() => setConfirmationOpen(false)}
      >
        <Text>Are you sure you want to activate staff?</Text>
        <Flex gap={10} mt={20} justify={"flex-end"}>
          <Button
            color="red"
            variant="light"
            onClick={() => setConfirmationOpen(false)}
          >
            Cancel
          </Button>
          <Button
            color="yellow"
            variant="filled"
            onClick={() => handleConfirmationSubmit(true)}
          >
            Force Activate
          </Button>
        </Flex>
      </Modal>
    </tr>
  );
};

export default SkyPointStaffTableRow;
